// register component as global
// define component naming with kebab-case
const vipcommissionboxCmp = Vue.component("vipcommission-box-component", {
  template: `<div
    class="garb_level_block home-membership-item"
    style="display: flex; align-items: center; justify-content: space-between"
  >
    <div style="display: flex; align-items: center">
      <img class="vip-icon" :src="levelPic" alt="VIP badge" v-if="levelPic!=''"/>
      <span class="home-level-name primary-block-text-color"
        >{{levelName}}</span
      >
    </div>
    <span
      class="home-level-rate primary-block-text-color"
      style="font-weight: 600"
      >{{levelCommissionPerc}}%</span
    >
  </div>`,
  props: {
    levelPic: {
      type: String,
      required: true,
    },
    levelName: {
      type: String,
      required: true,
    },
    levelCommissionPerc: {
      type: String,
      default: "0",
    },
  },
  data: function () {
    return {};
  },
  mounted() {},
});
